import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IUpcomingEventProps extends IBaseElementProps {
	/**
	 * Upcoming Event Intro Text
	 */
	introText?: string;
	/**
	 * Upcoming Event Date
	 */
	date?: string;
	/**
	 * Upcoming Event Heading
	 */
	heading?: string;
	/**
	 * Upcoming Event Link
	 */
	link?: ILink;
}

/**
 * Upcoming Events
 * @block
 * @icon calendar
 */
const UpcomingEvent: React.FC<IUpcomingEventProps> = ({
	introText,
	date,
	heading,
	link,
	id,
	className,
	classNames = [],
}) => (
	<div
		id={id}
		className={cn(
			'calian-upcoming-event',
			{
				'calian-upcoming-event--has-intro-text': introText,
			},
			className,
			...classNames,
		)}
	>
		{introText && (
			<div className="calian-upcoming-event__intro-text">{introText}</div>
		)}
		{date && <div className="calian-upcoming-event__date">{date}</div>}
		{heading && (
			<h4 className="calian-upcoming-event__heading">{heading}</h4>
		)}
		{link?.label && (
			<Button
				{...link}
				className="calian-upcoming-event__button btn btn-sm btn-light"
			/>
		)}
	</div>
);

export default UpcomingEvent;
